var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn-toggle",on:{"click":_vm.addEmbed}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'code']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }